import React from 'react';

const overlay = props => {
  const { 
    children, 
    style, 
    overlayStyle, 
    onClick, 
    overlayShadeClass,
    closeButtonEnabled, 
    onCloseButtonClick,
     } = props;

  return (
    <div className="Overlay" style={style}>
      <div className={"OverlayShade " + overlayShadeClass} onClick={onClick} style={overlayStyle}>
        <button type="button" disabled={!closeButtonEnabled} className="close" aria-label="Close" onClick={onCloseButtonClick}>
          <span aria-hidden="true">×</span>
        </button>
        {children}
      </div>
    </div>
  );
};

overlay.defaultProps = {
  closeButtonEnabled: true,
};

export default overlay;



// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/common/overlay.js